const GOOGLE_API_KEY = 'AIzaSyAXa2iasklc23yJkUBpw-1JOtow1PbWEgA';
const PLACE_ID = 'ChIJPx_wVQBvWkcRME9LtYV0rmQ';
const GOOGLE_MAPS_URL = 'https://maps.google.com/?cid=7254864167361531696';

interface Review {
  authorName: string;
  photoUrl?: string;
  rating: number;
  text: string;
  timeDesc: string;
}

const REAL_REVIEWS: Review[] = [
  {
    authorName: 'Nikola Jakovljević',
    photoUrl: 'https://lh3.googleusercontent.com/a-/ALV-UjWgTjzuUO0iz8bssD1i2nIxlk3UDV0ayzkRQC-X69awNBTXbutm=s128-c0x00000000-cc-rp-mo',
    rating: 5,
    text: 'Perfection in one place! If you are looking to modify your car with excellent carbon fiber materials this is the right place. The details and quality are amazing. Your car can look and feel like something completely new. All the best to the great Uroš who is truly one great professional!',
    timeDesc: 'a month ago',
  },
  {
    authorName: 'Lloyd Bonte',
    photoUrl: 'https://lh3.googleusercontent.com/a/ACg8ocI6yy_Les_SFglApxIDZlSRqWfmZARHoIRm2ll5vyDqDjB80A=s128-c0x00000000-cc-rp-mo-ba3',
    rating: 5,
    text: 'Ordered a Carbon Fiber exhaust surround for the Megane rs 4. Fits perfectly. Good price and delivered perfectly, as promised. Also gave good advice on how to remove the original part and fit the new one. Quality part!',
    timeDesc: '8 months ago',
  },
  {
    authorName: 'Ioannis ios Swiss',
    photoUrl: 'https://lh3.googleusercontent.com/a-/ALV-UjV9ONsv1TpHqlMSUkagyIyCcvYS0O4WBnZGX9EGdvx7BbDIRb0=s128-c0x00000000-cc-rp-mo-ba3',
    rating: 5,
    text: 'Perfect Quality very friendly guy really recommended!!! I have bought a carbon exhaust cover for my Renault megane 4 Rs and I was really pleased. Fast delivery and it is a very easy fit no special tools or skills required!',
    timeDesc: '7 months ago',
  },
  {
    authorName: "Luke O'Rourke",
    photoUrl: 'https://lh3.googleusercontent.com/a/ACg8ocK4GX6fohhAmkgcRtLUpHh2mZSkqt0PLOvEUNnHY8FBLBqA02c=s128-c0x00000000-cc-rp-mo',
    rating: 5,
    text: "Awesome customer service from them. Constant contact with progress of my order and quickly gained my trust with being on the other side of Europe. First UK client would happily use again and again till my bank account is empty",
    timeDesc: '8 months ago',
  },
  {
    authorName: 'Vlada Minic',
    photoUrl: 'https://lh3.googleusercontent.com/a-/ALV-UjVtoZNPyjP2RVpbpabsgtfJPpltq7LM0BH1U_rvN99W0jry-Bnw=s128-c0x00000000-cc-rp-mo',
    rating: 5,
    text: 'Easy to collaborate, the guy knows what he is doing, really professional and quick. Parts are of course top quality!',
    timeDesc: '3 months ago',
  },
];

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map(i => (
        <i
          key={i}
          className={`text-lg md:text-xl ${i <= rating ? 'ri-star-fill text-black' : 'ri-star-line text-gray-300'}`}
        />
      ))}
    </div>
  );
}

function Avatar({ name, photoUrl }: { name: string; photoUrl?: string }) {
  const [imgOk, setImgOk] = useState(true);
  const parts = name.trim().split(' ');
  const initials = parts.length >= 2
    ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    : name.slice(0, 2).toUpperCase();

  if (photoUrl && imgOk) {
    return (
      <img
        src={photoUrl}
        alt={name}
        referrerPolicy="no-referrer"
        className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover flex-shrink-0 border-2 border-gray-200 group-hover:border-black transition-colors"
        onError={() => setImgOk(false)}
      />
    );
  }
  return (
    <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-black flex items-center justify-center flex-shrink-0">
      <span className="text-white font-black text-sm tracking-wider">{initials}</span>
    </div>
  );
}

export default function Reviews() {
  // Start with real reviews immediately — no loading flicker
  const [reviews, setReviews] = useState<Review[]>(REAL_REVIEWS);
  const [rating, setRating] = useState(5);
  const [totalRatings, setTotalRatings] = useState(52);
  const [active, setActive] = useState(0);

  // Auto-advance
  useEffect(() => {
    const t = setInterval(() => setActive(i => (i + 1) % reviews.length), 5000);
    return () => clearInterval(t);
  }, [reviews.length]);

  const prev = () => setActive(i => (i - 1 + reviews.length) % reviews.length);
  const next = () => setActive(i => (i + 1) % reviews.length);

  useEffect(() => {
    // Try new Places API (supports CORS) to get fresh data
    (async () => {
      try {
        const res = await fetch(`https://places.googleapis.com/v1/places/${PLACE_ID}`, {
          headers: {
            'X-Goog-Api-Key': GOOGLE_API_KEY,
            'X-Goog-FieldMask': 'reviews,rating,userRatingCount',
          },
        });
        if (!res.ok) return;
        const data = await res.json();

        if (data.rating) setRating(data.rating);
        if (data.userRatingCount) setTotalRatings(data.userRatingCount);

        const fetched: Review[] = (data.reviews ?? []).map((r: any) => ({
          authorName: r.authorAttribution?.displayName ?? 'Anonymous',
          photoUrl: r.authorAttribution?.photoUri,
          rating: r.rating ?? 5,
          text: r.text?.text ?? '',
          timeDesc: r.relativePublishTimeDescription ?? '',
        })).filter((r: Review) => r.text);

        if (fetched.length > 0) setReviews(fetched);
      } catch {
        // keep hardcoded real reviews
      }
    })();
  }, []);

  return (
    <section id="reviews" className="bg-white py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">

        {/* Stats Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12 md:mb-20">
          <div className="text-center p-5 md:p-8 bg-gray-50 border border-gray-200">
            <div className="flex items-center justify-center gap-1 md:gap-2 mb-2 md:mb-3">
              <span className="text-3xl md:text-5xl font-black text-black">{rating.toFixed(1)}</span>
              <i className="ri-star-fill text-black text-xl md:text-3xl"></i>
            </div>
            <div className="text-gray-600 text-xs font-semibold uppercase tracking-wider">Google Rating</div>
          </div>
          <div className="text-center p-5 md:p-8 bg-gray-50 border border-gray-200">
            <div className="text-3xl md:text-5xl font-black text-black mb-2 md:mb-3">{totalRatings}+</div>
            <div className="text-gray-600 text-xs font-semibold uppercase tracking-wider">Google Reviews</div>
          </div>
          <div className="text-center p-5 md:p-8 bg-gray-50 border border-gray-200">
            <div className="text-3xl md:text-5xl font-black text-black mb-2 md:mb-3">98%</div>
            <div className="text-gray-600 text-xs font-semibold uppercase tracking-wider">Recommend Us</div>
          </div>
          <div className="text-center p-5 md:p-8 bg-gray-50 border border-gray-200">
            <div className="text-3xl md:text-5xl font-black text-black mb-2 md:mb-3">40+</div>
            <div className="text-gray-600 text-xs font-semibold uppercase tracking-wider">Countries Shipped</div>
          </div>
        </div>

        {/* Section Title */}
        <div className="text-center mb-10 md:mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-[2px] bg-black"></div>
            <span className="text-gray-500 text-xs uppercase tracking-[3px] font-bold">Verified</span>
            <div className="w-8 h-[2px] bg-black"></div>
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-black mb-3 md:mb-4 tracking-tight">GOOGLE REVIEWS</h2>
          <p className="text-gray-600 text-base md:text-lg">Real customers. Real feedback.</p>
        </div>

        {/* Carousel */}
        <div className="relative mb-12 md:mb-20">
          {/* Card */}
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${active * 100}%)` }}
            >
              {reviews.map((review, index) => (
                <div key={index} className="w-full flex-shrink-0 px-0 sm:px-16 md:px-28 lg:px-40">
                  <div className="bg-white border-2 border-gray-200 p-7 md:p-12 flex flex-col">
                    <div className="mb-5">
                      <StarRating rating={review.rating} />
                    </div>
                    <p className="text-gray-800 text-lg md:text-xl leading-relaxed mb-8 flex-1 font-medium">
                      "{review.text}"
                    </p>
                    <div className="flex items-center gap-4 pt-5 border-t border-gray-100">
                      <Avatar name={review.authorName} photoUrl={review.photoUrl} />
                      <div className="flex-1 min-w-0">
                        <div className="text-black font-bold text-base truncate">{review.authorName}</div>
                        {review.timeDesc && (
                          <div className="text-gray-400 text-xs mt-0.5">{review.timeDesc}</div>
                        )}
                      </div>
                      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white border border-gray-200 flex items-center justify-center">
                        <svg viewBox="0 0 24 24" className="w-4 h-4" xmlns="http://www.w3.org/2000/svg">
                          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Prev / Next arrows */}
          <button
            onClick={prev}
            className="absolute left-0 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-black text-white flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>
          <button
            onClick={next}
            className="absolute right-0 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-black text-white flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mb-12 md:mb-20">
          {reviews.map((_, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${i === active ? 'w-8 bg-black' : 'w-1.5 bg-gray-300'}`}
            />
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href={GOOGLE_MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 bg-black text-white px-7 md:px-10 py-4 md:py-5 text-sm md:text-base font-bold uppercase tracking-wider hover:bg-gray-900 transition-all whitespace-nowrap cursor-pointer"
          >
            Read All Reviews on Google
            <i className="ri-arrow-right-line text-lg md:text-xl group-hover:translate-x-2 transition-transform"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
